import React from 'react'
import { Outlet } from 'react-router-dom'
import CommandPalette from './CommandPalette'

export default function Layout() {
  return (
    <div className="min-h-screen bg-base-100">
      <main className="w-full h-screen">
        <Outlet />
      </main>
      <CommandPalette />
    </div>
  )
}
